<template>
  <div>
    <el-form-item :label="$t('scheduleClassesMonth.scheduleCycle')">
      <el-select v-model="scheduleCycle" :placeholder="$t('scheduleClassesMonth.scheduleCyclePlaceholder')"
        @change="changeInspectionPeriod" style="width:100%">
        <el-option v-for="item in months" :label="item.text" :key="item.value" :value="item.value" />
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('scheduleClassesMonth.scheduleInfo')">
      <div class="schedule-days-container">
        <div v-for="(item, index) in days" :key="index" class="schedule-day-item" @click="changeWorkdayInfo(item)">
          <div class="day-number">{{ item.day }}</div>
          <div class="workday-name">{{ item.workdayName }}</div>
          <div v-for="(time, timeIndex) in item.times" :key="timeIndex" class="time-range">
            {{ time.startTime }}-{{ time.endTime }}
          </div>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ScheduleClassesMonth',
  props: {
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      scheduleCycle: 1,
      months:[
        {text:'1月',value:'1'},
        {text:'2月',value:'2'},
        {text:'3月',value:'3'},
        {text:'4月',value:'4'},
        {text:'5月',value:'5'},
        {text:'6月',value:'6'},
        {text:'7月',value:'7'},
        {text:'8月',value:'8'},
        {text:'9月',value:'9'},
        {text:'10月',value:'10'},
        {text:'11月',value:'11'},
        {text:'12月',value:'12'}],
      days: []
    }
  },
  created() {
    console.log(JSON.stringify(this.initialData))
    if(this.initialData.scheduleCycle){
      this.scheduleCycle = this.initialData.scheduleCycle
    }
    if (this.initialData.days && this.initialData.days.length > 0) {
      this.days = [...this.initialData.days]
      this.scheduleCycle = this.initialData.scheduleCycle
    } else {
      this.changeInspectionPeriod()
    }
  },
  methods: {
    initData(scheduleCycle) {
      this.scheduleCycle = scheduleCycle
      this.changeInspectionPeriod()
    },
    notify(_params) {
      this.days = _params.days;
      this.scheduleCycle = _params.scheduleCycle;
      if (_params.days && _params.days.length > 0) {
        return;
      }
      this.changeInspectionPeriod();
    },
    changeInspectionPeriod() {
      this.days = []
      var data = this.getDaysInCurrentMonth()
      for (let cycleIndex = 0; cycleIndex < data; cycleIndex++) {
        this.days.push({
          day: cycleIndex + 1,
          workday: '2002',
          workdayName: this.$t('scheduleClassesMonth.rest'),
          times: []
        })
      }
      this.$emit('cycleChange', this.scheduleCycle)
      this.$emit('dayChange', this.days)
    },
    getDaysInCurrentMonth() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = this.scheduleCycle;
      const lastDay = new Date(year, month, 0).getDate();
      return lastDay;
    },
    changeWorkdayInfo(item) {
      this.$emit('editDay', item)
    },
    getDaysData() {
      return this.days
    }
  }
}
</script>

<style lang="scss" scoped>
.schedule-days-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.schedule-day-item {
  width: calc(16.66% - 10px);
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .day-number {
    font-weight: bold;
    margin-bottom: 5px;
  }

  .workday-name {
    margin-bottom: 5px;
  }

  .time-range {
    font-size: 12px;
    color: #666;
  }
}
</style>